module.exports = __webpack_public_path__ + "img/RBS04_thumb_loading.fceb17fe.jpg";